import { RESETHUBUNGANINVESTOR, SETHUBUNGANINVESTOR, SETFILEBYID, RESETFILEBYID } from "./hubunganinvestorTypes";

const initialState = {
    data: [],
    fileById: null
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SETHUBUNGANINVESTOR:
            return {
                ...state,
                ...payload
            };
        case RESETHUBUNGANINVESTOR:
            return {
                ...state,
                data: []
            };
        case SETFILEBYID:
            return{
                ...state,
                fileById: payload
            };
        case RESETFILEBYID:
            return{
                ...state,
                fileById: payload
            };
        default:
            return state;
    }
}

export default reducer;